import { render, staticRenderFns } from "./addcheck.vue?vue&type=template&id=4211ff5a&scoped=true&"
import script from "./addcheck.vue?vue&type=script&lang=js&"
export * from "./addcheck.vue?vue&type=script&lang=js&"
import style0 from "./addcheck.vue?vue&type=style&index=0&id=4211ff5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4211ff5a",
  null
  
)

export default component.exports